import { useEffect } from 'react'
import {
  useGetShipmentTrackAndTraceLazyQuery,
  ShipmentTrackAndTrace,
} from '../../generated/graphql'
import { ApolloResult } from '../../common/ApolloResult'
import { date, format, trackAndTraceExceptionIcon } from '../../common/utils/formatter'
import { ColumnWithStringAccessorSupport } from '../../common/utils/types'
import { TrackAndTraceEvents } from './TrackAndTraceEvents'
import { TrackAndTraceGoodsHolders } from './TrackAndTraceGoodsHolders'

export function ShipmentTrackAndTraceEvents({ packlistNumber }) {
  const [fetchTrackAndTrace, queryResult] = useGetShipmentTrackAndTraceLazyQuery({
    variables: {
      packlistNumber,
    },
    context: {
      page: 'shipment',
    },
  })

  const groupedTrackAndTraceEvents = queryResult.data?.getShipmentTrackAndTrace

  //Use effect to force refresh when the page is revisited
  useEffect(() => {
    fetchTrackAndTrace()
  }, [fetchTrackAndTrace, packlistNumber])

  return (
    <ApolloResult {...queryResult}>
      <TrackAndTraceEvents
        trackAndTraceEvents={groupedTrackAndTraceEvents}
        columns={shipmentPageTrackAndTraceColumns}
      />
    </ApolloResult>
  )
}

const shipmentPageTrackAndTraceColumns: ColumnWithStringAccessorSupport<ShipmentTrackAndTrace>[] = [
  {
    Header: ' ',
    accessor: 'event.isException',
    Cell: format(trackAndTraceExceptionIcon),
  },
  {
    Header: 'Time',
    accessor: 'event.eventTimestamp',
    Cell: format(date),
  },
  { Header: 'Status', accessor: 'event.intermediateStatusCode' },
  {
    Header: 'Description',
    accessor: (shipmentTrackTrace) =>
      !shipmentTrackTrace.event?.intermediateStatusCode &&
      !shipmentTrackTrace.event?.intermediateStatusDescription
        ? shipmentTrackTrace.event?.carrierStatusDescription
        : shipmentTrackTrace.event?.intermediateStatusDescription,
  },
  { Header: 'Source', accessor: 'sourceSystemName' },
  {
    Header: 'Carton Count',
    accessor: (e) => e,
    Cell: (e) => <TrackAndTraceGoodsHolders trackAndTraceEvent={e.value} />,
  },
]
